import { ReactNode } from 'react';

import UnauthorizedPage from '@occc-app/routes/Unauthorized';
import { ConfigGuard } from '@occc-app/App/guards';
import { Can } from '@occc-app/App/PolicyBasedAccessControl';
import { PolicyWithParams } from '@occc-app/App/PolicyBasedAccessControl/types';

import { RetailerNetworkViewGuard } from './retailer-network-view.guard';

type RetailerNetworkGuardProps = {
  policyWithParams: PolicyWithParams;
  children: ReactNode;
};

export const RetailerNetworkGuard = ({ policyWithParams, children }: RetailerNetworkGuardProps) => {
  return (
    <ConfigGuard isFeatureEnabled={(config) => config.retailerConnect.enabled}>
      <RetailerNetworkViewGuard>
        <Can I={policyWithParams} fallback={<UnauthorizedPage />}>
          {children}
        </Can>
      </RetailerNetworkViewGuard>
    </ConfigGuard>
  );
};
